export class JsonSchemaFormController {
  public static $inject = ['$scope', '$injector', '$http', '$translate'];
  public service: any;
  public selectedSchemaName: string;
  public schemaForms: any;
  public originalSchema: any;
  public localePath: string;
  public required: boolean;
  public currentLocale: string;
  public schemaServiceName: string;
  public options: any;
  public cancel: Function;
  public ok: Function;
  public selectedSchemaId: string;
  public schemaModel: any;
  public form: any;
  public fetchSchemaTypes: boolean;
  public model: any;
  public schema: any;
  public schemaForm: any;
  public schemaType: string;
  public JsonRefs: any;
  public currentSchemaId: string;
  public schemaTypesList: Array<string>;
  private inEditMode = false;

  constructor(
    private $scope: ng.IScope,
    private $injector: ng.auto.IInjectorService,
    private $http: ng.IHttpService,
    private $translate: ng.translate.ITranslateService
  ) {
    // tslint:disable-next-line: forin
    for (const propertyName in this.$scope.vm) {
      this[propertyName] = this.$scope.vm[propertyName];
    }

    this.activate();
  }

  /**
   * Calls the cancel function if present
   */
  public cancelForm = () => {
    if (this.cancel) {
      this.cancel();
    }
  }

  /**
   * Posts the form data to the ok function while validating the results
   */
  public okForm = () => {
    let data;
    this.$scope.$broadcast('schemaFormValidate');

    if (this.form.$valid) {
      if (angular.isDefined(this.selectedSchemaId)) {
        data = {};
        data.fields = this.schemaModel;
        data.type = this.selectedSchemaId;

        if (this.schemaServiceName === 'interimRuleTemplateService') {
          data = {};
          data.ruleTemplate = {
            link: '/interim-payment-rule-templates/' + this.selectedSchemaId
          };
          data.ruleParameterValues = this.schemaModel;

          if (angular.isDefined(this.selectedSchemaName)) {
            data.ruleTemplate.name = this.selectedSchemaName;
          }
        }

        if (data.fields) {
          data.fields = this.overwriteFieldData(data.fields);
        }
      }

      if (data && data.fields) {
        _.forIn(this.schema.properties, (object: any, key: string) => {
          if (object.type === 'boolean') {
            this.handleNullBoolean(data, key);
          }

          if (object.type === 'array') {
            this.handleNullArray(data, key);
          }
        });
      }

      this.ok(data);
    }
  }

  /**
   * Populates the schema fields and data from the schema id entered
   * @param currentSchemaId the schema id to get data for
   * @param isFirstLoad flag to determine if this is first time the schema form is being loaded in the UI
   */
  public updateCurrentSchema = (currentSchemaId: string, isFirstLoad?: boolean) => {
    if (angular.isDefined(this.model) && angular.isDefined(this.model.fields)) {
      this.updateTimebandsOnCurrentSchema();

      if (this.schemaServiceName === 'productSchemaService') {
        this.schemaModel = this.model.fields;
      } else {
        this.schemaModel = this.model.fields.customData;
      }
    } else {
      this.schemaModel = {};
    }

    if (this.schemaServiceName === 'interimRuleTemplateService' && angular.isDefined(this.model)) {
      this.schemaModel = this.model.ruleParameterValues;
    }

    if (angular.isDefined(currentSchemaId)) {
      if (isFirstLoad) {
        this.inEditMode = true;
      }
      this.selectedSchemaId = currentSchemaId;
      this.schemaForm = this.schemaForms[this.selectedSchemaId];

      this.service.getSchema(currentSchemaId).then((data: {
        schema: InterACT.Interfaces.IJsonSchema;
        name: string;
        parameters: string;
        fields: any;
      }) => {
        if (this.schemaServiceName === 'productSchemaService') {
          this.generateForm(data.schema);
        } else if (this.schemaServiceName === 'interimRuleTemplateService') {
          this.schemaType = currentSchemaId;
          this.selectedSchemaName = data.name[this.currentLocale];
          this.generateForm(JSON.parse(data.parameters));
        } else {
          this.schemaType = currentSchemaId;
          this.selectedSchemaName = data.name;
          this.generateForm(data.fields);
        }
      });
    }
  }

  /**
   * Clears the schema form of data
   */
  public clearSelectedSchema = () => {
    this.selectedSchemaId = undefined;
    this.schemaType = undefined;
    this.schemaModel = {};
  }

  private handleNullTimebands = (data: any) => {
    if (
      data.fields.timebands.length === 0 ||
      data.fields.timebands[0] === 'null' ||
      data.fields.timebands[0] === undefined ||
      data.fields.timebands[0] === '') {
      data.fields.timebands = undefined;
    }
  }

  /**
   * A methods that handles null arrays
   */
  private handleNullArray = (data: any, key: string) => {
    if (
      data.fields[key].length === 0 ||
      data.fields[key][0] === 'null' ||
      data.fields[key][0] === undefined ||
      data.fields[key][0] === '') {
      data.fields[key] = undefined;
    }
  }

  /**
   * A method that handles null booleans
   */
  private handleNullBoolean = (data: any, key: string) => {
    if (!data.fields[key]) {
      data.fields[key] = false;
    }
  }

  /**
   * A method that updated timebands on the current schema
   */
  private updateTimebandsOnCurrentSchema() {
    if (this.model.fields.timebands && this.model.fields.timebands.length > 0 && this.model.fields.timebands[0] === null) {
      this.model.fields.timebands = [];
    }
  }

  /**
   * Initialises the controller
   */
  private activate = () => {
    this.setLocalePath();
    this.currentLocale = this.$translate.use();

    this.service = this.$injector.get(this.schemaServiceName);
    this.getSchemaTypes();
    this.options = {
      formDefaults: {
        feedback: '{ \'fa\': true, \'fa-asterisk\': form.required && !hasSuccess() && !hasError() ,\'fa-check\': hasSuccess(), \'fa-remove\': hasError() }'
      },
      validateOnRender: false
    };

    this.$http.get(this.localePath + this.$translate.use() + '.json').then((result) => {
      this.schemaForms = result.data;

      this.updateCurrentSchema(this.currentSchemaId, true);
    });
  }

  /**
   * Overwrited the data model using planned overwrites
   * @param fields the fields object found in the data model
   * @returns the fields object with overwritten fields where required
   */
  private overwriteFieldData = (fields: any) => {
    if (fields.IPEBitMap === 26) {
      delete fields.IIN;
    }

    for (const key in fields) {
      if (fields[key] === '' || fields[key] === null) {
        delete fields[key];
      }
    }
    return fields;
  }

  /**
   * Sets the locale path for different schema services
   */
  private setLocalePath = () => {
    this.localePath = 'assets/locale/schema_form/';
    this.required = true;
    if (this.schemaServiceName === 'customerSchemaService') {
      this.localePath += 'customer/';
      this.required = false;
    }

    if (this.schemaServiceName === 'interimRuleTemplateService') {
      this.localePath += 'interim/';
    }
  }

  /**
   * Generates the schema form using the data from the schema service
   * @param schema the data from the schema service
   */
  private generateForm = (schema: InterACT.Interfaces.IJsonSchema) => {
    this.originalSchema = schema;
    /*eslint-disable */
    (<any>window).JsonRefs.resolveRefs(schema, (err, resolvedSchema: InterACT.Interfaces.IJsonSchema) => {
      /*eslint-enable */
      if (err) {
        throw err;
      } else {
        if (resolvedSchema.properties.EntitlementExpiryDate) {
          resolvedSchema.properties.EntitlementExpiryDate.format = 'date';
        }

        // Need this wrapped in $scope.$apply below since the vm.schema is being updated
        // by a method outside of AngularJS (JsonRefs lib)
        const mergedSchema = _.merge(this.originalSchema, resolvedSchema);
        this.schema = this.inEditMode ? this.clearSchemaDefaultValues(mergedSchema) : mergedSchema;
        this.$scope.$apply();

        this.$scope.$broadcast('schemaFormValidate');
      }
    });
  }

  /**
   * Populates the schemaTypesList from the schema service
   */
  private getSchemaTypes = () => {
    if (this.fetchSchemaTypes) {
      this.service.getList().then(() => {
        this.schemaTypesList = this.service.listNames();
      });
    }
  }

  /**
   * A method which clears schema default values on load
   */
  private clearSchemaDefaultValues = (schema: InterACT.Interfaces.IJsonSchema) => {
    _.forIn(schema.properties, (_propertyValue, propertyName) => {
      if (schema.properties[propertyName].type === 'array') {
        schema.properties[propertyName].default = [];
      } else if (!_.has(this.schemaModel, propertyName)) {
        schema.properties[propertyName].default = '';
      }
    });

    return schema;
  }
}